export enum InformationType {
  news = 1,
  course = 2,
  events = 3,
  document = 4
}